export const routes = {
    home: '/',
    goalsetting: '/goalsetting/*',
    sales: '/sales/*',
    customers: '/customers',
    competition: '/competition',
    settings: '/settings',
    ordering: '/ordering',
    onboarding: '/onboarding',
    smssetup: '/sms-setup',
    insights: '/insights',
    mylocations: '/my-locations',
};
export const logoutUrl = {
    dev: 'https://login-dev.moneris.com',
    qa: 'https://login-qa.moneris.com',
    prod: 'https://login.moneris.com',
};
